import { useQueries } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { InvitationRecord } from "../invitation.types";

export type UseFetchMultipleInvitationRecordsArgs = {
  invitationIds: number[];
  enabled?: boolean;
};

/**
 * Fetch invitation records for multiple invitations in parallel.
 * Returns combined list of records from all invitations.
 */
export function useFetchMultipleInvitationRecords({
  invitationIds,
  enabled = true,
}: UseFetchMultipleInvitationRecordsArgs) {
  const queries = useQueries({
    queries: invitationIds.map((id) => ({
      queryKey: ["invitation-records", id],
      queryFn: () => apiRequest(`/invitation/${id}/records/`) as Promise<InvitationRecord[]>,
      enabled: enabled && !!id,
    })),
  });

  const isLoading = queries.some((q) => q.isLoading);
  const isError = queries.some((q) => q.isError);
  const data = queries.flatMap((q) => q.data ?? []);

  return { data, isLoading, isError };
}

export default useFetchMultipleInvitationRecords;
